/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import classnames from 'classnames';
import { StyledTablePagination } from './tablePaginationStyles';
import { EmbersTablePaginationItem } from './item/tablePaginationItem';
import { useRtl } from '../../../rtlProvider';
import { AccessibleIcon } from '../../components/accessibleIcon/accessibleIcon';
import { useIntl } from 'react-intl';
export var EmbersTablePagination = function EmbersTablePagination(props) {
  var intl = useIntl();
  var _useRtl = useRtl(),
    transformRTL = _useRtl.transformRTL;
  var onPaginationChange = props.onPaginationChange,
    pageCount = props.pageCount,
    currentPage = props.currentPage,
    mixpanelProps = props.mixpanelProps;
  if (!pageCount || !currentPage || pageCount === 1) return null;
  var generatePageNumbers = function generatePageNumbers() {
    if (currentPage <= 2) return [1, 2, 3, 4, 5];else if (currentPage >= pageCount - 2) return Array.from(Array(pageCount).keys()).slice(pageCount - 4).concat(pageCount);else return [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2];
  };
  var handlePaginationChange = function handlePaginationChange(page) {
    var _mixpanelProps$tracke, _mixpanelProps$tracke2;
    mixpanelProps === null || mixpanelProps === void 0 || (_mixpanelProps$tracke = (_mixpanelProps$tracke2 = mixpanelProps.tracker).changePageNo) === null || _mixpanelProps$tracke === void 0 || _mixpanelProps$tracke.call(_mixpanelProps$tracke2, mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tableName, page);
    onPaginationChange === null || onPaginationChange === void 0 || onPaginationChange(page);
  };
  var renderPaginationItem = function renderPaginationItem() {
    if (pageCount <= 5) {
      return Array.from(Array(pageCount).keys()).map(function (item) {
        return /*#__PURE__*/React.createElement(EmbersTablePaginationItem, {
          active: item + 1 === currentPage,
          key: item + 1,
          page: item + 1,
          onClick: handlePaginationChange
        });
      });
    }
    return generatePageNumbers().map(function (item) {
      return /*#__PURE__*/React.createElement(EmbersTablePaginationItem, {
        active: item === currentPage,
        key: item,
        page: item,
        onClick: handlePaginationChange
      });
    });
  };
  var renderPaginationArrow = function renderPaginationArrow(direction) {
    var isLeft = direction === 'left';
    var handleClick = function handleClick() {
      handlePaginationChange(isLeft ? currentPage - 1 : currentPage + 1);
    };
    var iconName = isLeft ? transformRTL('icon-chevron-left', 'icon-chevron-right') : transformRTL('icon-chevron-right', 'icon-chevron-left');
    return /*#__PURE__*/React.createElement(AccessibleIcon, {
      className: classnames('EmbersTablePagination-arrow', iconName, {
        'EmbersTablePagination-arrow-hidden': isLeft ? currentPage === 1 : currentPage === pageCount
      }),
      role: "button",
      "aria-label": isLeft ? intl.formatMessage({
        id: 'embers.table.pagination.left',
        defaultMessage: 'Previous page'
      }) : intl.formatMessage({
        id: 'embers.table.pagination.right',
        defaultMessage: 'Next page'
      }),
      onClick: handleClick
    });
  };
  return /*#__PURE__*/React.createElement(StyledTablePagination, {
    className: "EmbersTablePagination-root"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, renderPaginationArrow('left'), renderPaginationItem(), renderPaginationArrow('right')));
};